export default {
  title: 'Búsqueda de PMIS',
  labels: {
    search: 'Buscar por nombre o código de PMIS',
    searchDocuments: 'Buscar por código, nombre o tipo de soporte',
    results: 'Resultados',
    configurations: 'Configuraciones de PMIS',
    addConfiguration: 'Agregar configuración',
    deleteConfiguration: '¿Está seguro que desea eliminar la configuración de PMIS?',
    cannotRevert: 'Esta acción no se puede revertir',
    agreementsTitle: 'Convenios',
    servicesTitle: 'Servicios',
    supportsTitle: 'Soportes',
    searchAlert: 'Debe ingresar un nombre o código de PMIS',
  },
  headers: {
    code: 'Código',
    name: 'Nombre',
    services: 'Servicios',
    agreementCodes: 'Códigos de convenios',
    supportsRequired: 'Soportes requeridos',
    actions: 'Acciones',
  },
  detail: {
    title: 'Configuración de PMIS {code}',
    agreements: 'Convenios afectados',
    addAgreement: 'Agregar convenio',
    services: 'Servicios afectados',
    addService: 'Agregar servicio',
    supports: 'Soportes afectados',
    addSupport: 'Agregar soporte',
    updateSuccess: 'Configuración de PMIS actualizada exitosamente',
    updateError: 'Error al actualizar la configuración de PMIS',
    searchAgreement: 'Buscar por código de convenio',
    searchSupports: 'Buscar por código, nombre o tipo de soporte',
    productHeaders: {
      code: 'Código',
      name: 'Nombre de PMIS',
      agreementCode: 'Código de convenio',
    },
    agreementHeaders: {
      code: 'Código',
      payer: 'Pagador',
      serviceTypes: 'Tipos de servicio',
      actions: 'Acciones',
    },
    serviceHeaders: {
      code: 'Código de servicio',
      name: 'Nombre de servicio',
      actions: 'Acciones',
    },
    supportHeaders: {
      code: 'Código de soporte',
      name: 'Nombre de soporte',
      type: 'Tipo de soporte',
      actions: 'Acciones',
      required: 'Requerido'
    },
  }
}
